import React from 'react';

import GroupAndRandomiseParentHeader from '../GroupAndRandomiseParentHeader/GroupAndRandomiseParentHeader';
import addButton from '../../../../../../../../../../../assets/img/add.svg';
import SidePropertiesContainer from '../../../../SidePropertiesContainer/SidePropertiesContainer';
import SideProperties from '../../SideProperties/SideProperties';

import styles from '../../../Group.module.css';

export default function({
  isActiveGroup,
  actions,
  group,
  setGroupNameRef,
  containerStyle,
  state,
  elements,
  surveyStructure,
  groupNameRef,
  surveyListGroup
}) {
  return (
    <div>
      <div
        className={
          isActiveGroup
            ? `${styles.groupAndRandomiseWrapper} ${styles.active}`
            : styles.groupAndRandomiseWrapper
        }
        role="presentation"
        onClick={e => {
          e.stopPropagation();

          if (!isActiveGroup) {
            actions.setActiveFlow(group);
          }
        }}
      >
        <GroupAndRandomiseParentHeader
          setGroupNameRef={setGroupNameRef}
          group={group}
          actions={actions}
        />
        <div
          className={`${containerStyle} ${
            styles.groupAndRandomiseParentGroupContainer
          }`}
        >
          {elements}
        </div>
        <div className={styles.addGroupRandomiseGroupContainer}>
          <div
            className={styles.addGroupRandomiseGroupButton}
            role="presentation"
            onClick={e => {
              e.stopPropagation();
              actions.addGroupRandomiseChildGroup(group.id);
            }}
          >
            <img src={addButton} alt="add filter button" />
            Add a group
          </div>
        </div>
        {isActiveGroup && (
          <SidePropertiesContainer top={0} title="Edit group">
            <SideProperties
              actions={actions}
              group={group}
              surveyLists={state.surveyLists}
              surveyStructure={surveyStructure}
              groupNameRef={groupNameRef}
              surveyListGroup={surveyListGroup}
              isGroupAndRandomiseParent
            />
          </SidePropertiesContainer>
        )}
      </div>
    </div>
  );
}
